<template>
  <div>
    <p v-if="!rows.length" class="text-caption text--secondary mb-0">{{ $t('onboarding.commissioning.no-requirement') }}</p>
    <div v-for="row in rows" :key="row.requirement" class="d-flex align-start mb-3">
      <v-icon small class="mr-2 mt-1" :color="row.satisfiedAt ? 'green' : 'grey'">
        {{ row.satisfiedAt ? 'mdi-check-circle' : 'mdi-clock-outline' }}
      </v-icon>
      <div>
        <div class="font-weight-medium">{{ requirementLabel(row.requirement) }}</div>
        <div class="text-caption text--secondary">
          <template v-if="row.satisfiedAt">{{ $t('onboarding.commissioning.requirement-satisfied', { date: $options.filters.formatDate(row.satisfiedAt) }) }}</template>
          <template v-else>{{ $t(`onboarding.commissioning.requirement-by.${row.requirement}`) }}</template>
        </div>
        <!-- L'acompte : le dernier prélèvement, et le motif d'un refus. -->
        <div v-if="row.requirement === 'deposit' && order.deposit" class="text-caption">
          {{ $t(`onboarding.commissioning.deposit-status.${order.deposit.status}`, { amount: money(order.deposit.amount, order.deposit.currency) }) }}
          <span v-if="order.deposit.failureReason" class="red--text"> · {{ order.deposit.failureReason }}</span>
        </div>
        <div v-if="row.requirement === 'consent' && order.dataUse" class="text-caption">
          {{ $t(`onboarding.commissioning.data-use-value.${order.dataUse}`) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommissioningMixin from '../CommissioningMixin'

/**
 * Ce qu'il faut réunir avant la mise en service, levé (avec sa date) ou en attente (et de qui) : tous les prérequis sur
 * la fiche, ceux de la personne seulement dans le tiroir de la file (`only`).
 */
export default {
  name: 'OrderRequirementsList',

  mixins: [CommissioningMixin],

  props: {
    order: { type: Object, required: true },
    only: { type: Array, default: null },
  },

  computed: {
    rows() {
      const rows = this.order.requirements || []
      return this.only ? rows.filter(row => this.only.includes(row.requirement)) : rows
    },
  },

  methods: {
    money(amount, currency = 'EUR') {
      return new Intl.NumberFormat(this.$i18n.locale, { style: 'currency', currency: (currency || 'EUR').toUpperCase() }).format(amount)
    },
  },
}
</script>
